import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'weber-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Weber County School District',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8014767800,
  email: 'support@healthfully.co',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/weber/index.js